import clsx from 'clsx'
import { Button, MenuItem, TextField, Typography, Alert } from '@mui/material'
import React, { useState } from 'react'
import useTranslations from '../../../i18n/useTranslations'
import { useShippingSearchByCode } from '../../../services/shippingsTracking'

import Select from '../../../ui/components/select'

import useStyles from './styles'

const ContactForm = ({ name, email, phone }) => {
  const classes = useStyles()
  const formatMessage = useTranslations()
  const [selectedType, setSelectedType] = useState('')
  const [selectedReason, setSelectedReason] = useState('')
  const [shipmentNumber, setShipmentNumber] = useState('')
  const [shipmentNumberError, setShipmentNumberError] = useState(false)
  const [shipmentNumberNotFoundError, setShipmentNumberNotFoundError] =
    useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const { data, status } = useShippingSearchByCode(shipmentNumber)

  const reasonOptions = {
    [process.env.REACT_APP_CONTACT_FORM_INFORMATIC_SUPPORT]: [
      { value: 'CLIENTWEB_CI_1', label: 'noun:CLIENTWEB_CI_1' },
      { value: 'CLIENTWEB_CI_2', label: 'noun:CLIENTWEB_CI_2' },
      { value: 'CLIENTWEB_CI_3', label: 'noun:CLIENTWEB_CI_3' },
      { value: 'CLIENTWEB_OTROS', label: 'noun:other' },
    ],
    [process.env.REACT_APP_CONTACT_FORM_CUSTOMER_SUPPORT]: [
      { value: 'CLIENTWEB_ATC_1', label: 'noun:CLIENTWEB_ATC_1' },
      { value: 'CLIENTWEB_ATC_2', label: 'noun:CLIENTWEB_ATC_2' },
      { value: 'CLIENTWEB_OTROS', label: 'noun:other' },
    ],
    [process.env.REACT_APP_CONTACT_FORM_COMMERCIAL]: [
      { value: 'CLIENTWEB_SALES_1', label: 'noun:CLIENTWEB_SALES_1' },
      { value: 'CLIENTWEB_SALES_2', label: 'noun:CLIENTWEB_SALES_2' },
      { value: 'CLIENTWEB_OTROS', label: 'noun:other' },
    ],
    [process.env.REACT_APP_CONTACT_FORM_BILLING]: [
      { value: 'CLIENTWEB_BILL_1', label: 'noun:CLIENTWEB_BILL_1' },
      { value: 'CLIENTWEB_BILL_2', label: 'noun:CLIENTWEB_BILL_2' },
      { value: 'CLIENTWEB_OTROS', label: 'noun:other' },
    ],
  }

  function urlencodeFormData(fd) {
    var s = ''
    function encode(s) {
      return encodeURIComponent(s).replace(/%20/g, '+')
    }
    for (var pair of fd.entries()) {
      if (typeof pair[1] == 'string') {
        s += (s ? '&' : '') + encode(pair[0]) + '=' + encode(pair[1])
      }
    }
    return s
  }
  const handleSubmit = event => {
    event.preventDefault()
    if (selectedReason === 'CLIENTWEB_ATC_1') {
      if (shipmentNumber.length !== 22) {
        setShipmentNumberError(true)
        return
      }
      if (data.length === 0) {
        setShipmentNumberNotFoundError(true)
        return
      }

      if (status === 'success' && data) {
        setShipmentNumberNotFoundError(false)
        setShipmentNumberError(false)
        const formData = new FormData(event.target)
        const encodedFormData = urlencodeFormData(formData)
        fetch(event.target.action, {
          method: event.target.method,
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: encodedFormData,
        })
          .then(() => {
            setShowAlert(true)
          })
          .catch(() => setShowAlert(false))

        event.target.reset()
      } else {
        setShipmentNumberError(true)
        return
      }
    } else {
      const formData = new FormData(event.target)
      const encodedFormData = urlencodeFormData(formData)
      fetch(event.target.action, {
        method: event.target.method,
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: encodedFormData,
      })
        .then(() => {
          setShowAlert(true)
        })
        .catch(() => setShowAlert(false))

      event.target.reset()
    }
  }

  const handleTypeChange = event => {
    setSelectedType(event.target.value)
  }

  const handleReasonChange = event => {
    setSelectedReason(event.target.value)
  }

  return (
    <>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.formTitle)}
      >
        {formatMessage('help:write-your-message-here')}
      </Typography>
      <form
        action={process.env.REACT_APP_BACKEND_ENDPOINT_CONTACT_FORM_URL}
        method="post"
        className={classes.fields}
        onSubmit={handleSubmit}
      >
        <input
          type="hidden"
          name="orgid"
          value={process.env.REACT_APP_CONTACT_FORM_ORGID}
        />
        <input type="hidden" name="retURL" value={window.location.href} />
        <input type="hidden" name="type" value="REQUEST" />
        <input type="hidden" name="Origin" value="INTERNAL" />

        <TextField
          id="name"
          name="name"
          className="input-large"
          maxLength="80"
          label={formatMessage('noun:name-surname')}
          InputProps={{
            readOnly: true,
          }}
          defaultValue={name}
        />

        <TextField
          id="email"
          name="email"
          type="email"
          className="input-large"
          label={formatMessage('noun:email')}
          InputProps={{
            readOnly: true,
          }}
          defaultValue={email}
        />

        <TextField
          id="phone"
          name="phone"
          type="tel"
          className="input-large"
          maxLength="40"
          defaultValue={phone}
          label={formatMessage('noun:phone')}
        />

        <Select
          label="Área"
          labelId="type"
          name="recordType"
          required
          onChange={handleTypeChange}
          className="input-large"
        >
          <MenuItem value={process.env.REACT_APP_CONTACT_FORM_CUSTOMER_SUPPORT}>
            {formatMessage('help:customer-support')}
          </MenuItem>
          <MenuItem
            value={process.env.REACT_APP_CONTACT_FORM_INFORMATIC_SUPPORT}
          >
            {formatMessage('help:informatic-support')}
          </MenuItem>
          <MenuItem value={process.env.REACT_APP_CONTACT_FORM_COMMERCIAL}>
            {formatMessage('help:commercial')}
          </MenuItem>
          <MenuItem value={process.env.REACT_APP_CONTACT_FORM_BILLING}>
            {formatMessage('help:billing')}
          </MenuItem>
        </Select>

        {selectedType && reasonOptions[selectedType] && (
          <Select
            label="Razón"
            labelId="reason"
            name="Reason_type_code__c"
            required
            onChange={handleReasonChange}
            className="input-large"
          >
            {reasonOptions[selectedType].map(option => (
              <MenuItem key={option.value} value={option.value}>
                {formatMessage(option.label)}
              </MenuItem>
            ))}
          </Select>
        )}
        <div className="input-medium"></div>
        {selectedReason === 'CLIENTWEB_ATC_1' && (
          <TextField
            id="shipmentNumber"
            name="Shipping_code__c"
            required
            className="input-large"
            placeholder={formatMessage('help:shipmentNumber:placeholder')}
            maxLength="22"
            onChange={e => setShipmentNumber(e.target.value)}
            value={shipmentNumber}
            label={formatMessage('noun:shipping-number')}
            error={shipmentNumberError || shipmentNumberNotFoundError}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
            helperText={
              shipmentNumberError
                ? formatMessage('error:shipment-number:length')
                : shipmentNumberNotFoundError
                ? formatMessage('error:shipment-number:not-found')
                : ''
            }
          />
        )}
        <TextField
          id="subject"
          name="subject"
          required
          className="input-large"
          placeholder={formatMessage('help:subject:placeholder')}
          maxLength="40"
          label={formatMessage('noun:subject')}
        />

        <TextField
          id="description"
          name="description"
          multiline
          placeholder={formatMessage('help:description:placeholder')}
          rows="5"
          required
          className={clsx('input-full', classes.textArea)}
          label={formatMessage('noun:comments')}
        />

        {showAlert && (
          <Alert severity="success" className={classes.alertSuccess}>
            {formatMessage('help:success-form-sent')}
          </Alert>
        )}

        <Typography className={classes.info}>
          {formatMessage('help:contact-form-info')}
        </Typography>
        <Button type="submit">{formatMessage('help:send')}</Button>
      </form>
    </>
  )
}

ContactForm.propTypes = {}

export default ContactForm
